import { render, staticRenderFns } from "./PostPopover.vue?vue&type=template&id=a192de20&"
import script from "./PostPopover.vue?vue&type=script&lang=js&"
export * from "./PostPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports